<div>
    <div (mouseleave)="showDropDown = false">
        <button class="form-control text-left d-flex align-items-center flat" (click)="btnClicked()" required aria-label="Center Align">
            <span *ngIf="checkedList.length<=0" translate>lblSelectVehicleType</span>
            <span class="multiselect-checkbox" *ngIf="checkedList.length>0">{{checkedListName.join(', ')}}</span>
            <em class="fa fa-angle-down ml-auto"></em>
        </button>
        <div class="drop-show" *ngIf="showDropDown">
            <label *ngFor="let a of list;let i=index">
                <input type="checkbox" [(ngModel)]="a.checked" (change)="getSelectedValue(a)"
                    #vehicleTypeName="ngModel" />
                    <span *ngIf="i!==0">
                        <span class="w-66px">{{a.code}}</span>
                        <span class="mx-2 hide-ng-dropdown-panel">-</span>
                    </span>     
                    <span>{{a.name}}</span>
            </label>
        </div>
    </div>
    <div *ngIf="checkedListName?.length<1 && clicked" class="help-block text-danger">
        <span translate>lblPleaseSelectVehicleType</span>
    </div>
</div>